import { render } from "./AlgorithmView-img.vue?vue&type=template&id=259ec22b&scoped=true"
import script from "./AlgorithmView-img.vue?vue&type=script&lang=js"
export * from "./AlgorithmView-img.vue?vue&type=script&lang=js"

import "./AlgorithmView-img.vue?vue&type=style&index=0&id=259ec22b&scoped=true&lang=css"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259ec22b"]])

export default __exports__